import logo from "../images/distinguishedlogo.svg"
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import "./NavBar.css"

export default function NavBar(){
    
    function setSmoothScroll(event){
        event.preventDefault();
        const sectionId = event.target.getAttribute('href').replace('#', '');
        const section = document.getElementById(sectionId);
        const menuButton = document.getElementById("menu_button");
        section.scrollIntoView({ behavior: 'smooth' });
        menuButton.click();
    }

    React.useEffect(() =>{
        // Get all links with an href attribute that starts with '#'
        const links = document.querySelectorAll('div > a[href^="#"]');
        links.forEach(link => {
            link.addEventListener('click', setSmoothScroll);
            return () => {
                link.removeEventListener('click', setSmoothScroll)
            }
        });
    },[])

    const [navOpen, setNavOpen] = React.useState(false);

    function handleHamburgerMenu(){
        setNavOpen(!navOpen);
    }
    const navClass = `navbar-menu ${navOpen ? 'nav-open' : ''}`
    return (
        <div id="navbar_container">
            <div id="navbar_wrapper">
                <div id="navbar_logo">
                    <img src={logo} alt="Company Logo"/>
                </div>
                <div id="menu_button" onClick={handleHamburgerMenu}><FontAwesomeIcon icon={faBars} /></div>
                <nav id="navbar-menu" className={navClass}>
                    <ul>
                        <li><div className="nav_button"><a href="#home">Home</a></div></li>
                        <li><div className="nav_button"><a href="#about">About</a></div></li>
                        <li><div className="nav_button"><a href="#services">Services</a></div></li>
                        <li><div className="nav_button"><a href="#contacts">Contact Us</a></div></li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}